import { useQuery, useQueryClient } from "@tanstack/react-query"
import { GetUsuarioLoggedDtoProps } from "api/DTOs/GetUsuarioLoggedDto"
import { getUsuarioByCurrentUser } from "api/Usuario.service"

export function useUsuarioByCurrent() {
  const queryClient = useQueryClient()

  const {
    data: usuarioByCurrent,
    isLoading: usuarioByCurrentIsLoading,
    error: usuarioByCurrentError,
    refetch: usuarioByCurrentRefetch,
  } = useQuery<GetUsuarioLoggedDtoProps>({
    queryKey: ["getUsuarioByCurrentUser"],
    queryFn: () => getUsuarioByCurrentUser(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2,
    retry: false,
  })

  const usuarioInternoInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["getUsuarioByCurrentUser"] })

  return {
    usuarioByCurrent,
    usuarioByCurrentIsLoading,
    usuarioByCurrentError,
    usuarioByCurrentRefetch,
    usuarioInternoInvalidation,
  }
}
